import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'contact-form-acknowledgement-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatRipple,
    MatDialogModule
  ],
  template: `
  <div class="block bg-primary-800 text-white">
    <div class="p-4">
      <p>Thank you for reaching out to us! We'll get back to you shortly.</p>
      <button class="btn btn-text mt-4 source-color-white
        font-bold ml-auto"
        mat-ripple mat-dialog-close>OK</button>
    </div>
  </div>
  `
})
export class ContactFormAcknowledgementDialog {

  static open(dialog: MatDialog) {

    return dialog.open(this);
  }

}